/**
 * 转场特效 - basic(放大缩小渐变)
 * 2018-10-8
 */

;(function (root, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(this);
    } else {
        factory(root);
    }
})(this, function (root) {
    // 类构造函数
    function con(scene, option) {
        this.code = option.code || 'ZoomIn';
    }

    // 方法
    var methods = {
        init: function () {
            this.duration = 0.5; // 动效持续时间
            this.startAt = 0.25; // 开始时间（场景结束前n秒）

            return this.supr(this.startAt).then(function () {
            });
        },

        show: function (frame) {
            // 播放
            if (!this.isInit) return;
            this.supr(frame);

            var scene = this.scene,
                editor = scene.editor,
                sele = scene.element.player, // plyaer层的当前scene
                isRecover = false; // 是否需要恢复场景到正常

            // 播放层显示，对应scene显示
            editor.player.ele.show();
            sele.show();

            // 前250ms
            if (frame < this.entrance.end) {
                // 如果存在上一个场景页就不需要恢复
                this.prevs && (isRecover = true)

                this.showFirst(frame)
            }

            // 后250ms
            if (this.nexts && frame >= this.exit.start) {
                var nexts_ele = this.nexts.element.player; // player层中的下一个场景
                // 隐藏上一个场景页的遮罩
                this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();

                var offframe = frame - this.exit.start; // 当前帧减去动画开始时的帧(动画的帧)

                // 初始化下个场景页的css并显示
                nexts_ele.css({top: 0,left: 0,transform: '', opacity: ''});
                nexts_ele.show();

                switch(this.scene.effect.code) {
                    case 'ZoomIn':
                        // 本场景放大，下一个场景从0放大到1，遮盖本场景页
                        sele.css({transform: 'scale(' + this._easingAnim(offframe, 1, 0.25, this.totalFrame) + ')'})
                        nexts_ele.css({transform: 'scale(' + this._easingAnim(offframe, 0, 1, this.totalFrame) + ')'})
                        break;
                    case 'ZoomOut':
                        // 本场景保持在下个场景页上方缩小到0，下个场景页从1.25缩小到1
                        sele.css({transform: 'scale(' + this._easingAnim(offframe, 1, -1, this.totalFrame) + ')', zIndex: 9999})
                        nexts_ele.css({transform: 'scale(' + this._easingAnim(offframe, 1.25, -0.25, this.totalFrame) + ')'})
                        break;
                    case 'Fade':
                        // 本场景渐渐不透明
                        sele.css({opacity: this._easingAnim(offframe, 1, -1, this.totalFrame), zIndex: 9999})
                        break;
                }
                isRecover = true;
            }

            // 动画区间外，隐藏其它元素，恢复位置(本场景页)
            if (frame >= this.entrance.end && frame < this.exit.start) {
                this.showMiddle()
            }

            // 重置正常位置
            if (!isRecover) {
                sele.css({top: 0, left: 0, transform: '', zIndex: scene.index*5, opacity: ''});
                this.nexts && this.nexts.element.player.css({top: 0, left: 0, transform: '', opacity: ''});
            }
        },

        // 为下一个场景提供方法以完成动画衔接(注释对应上边)
        showNext: function (frame) {
            var sele = this.scene.element.player,
                nexts_ele = this.nexts.element.player;

            var _currentFrame = this.startAt * this.frameRate + frame;

            switch(this.scene.effect.code) {
                case 'ZoomIn':
                    sele.css({transform: 'scale(' + this._easingAnim(_currentFrame, 1, 0.25, this.totalFrame) + ')'})
                    nexts_ele.css({transform: 'scale(' + this._easingAnim(_currentFrame, 0, 1, this.totalFrame) + ')'})
                    break;
                case 'ZoomOut':
                    sele.css({transform: 'scale(' + this._easingAnim(_currentFrame, 1, -1, this.totalFrame) + ')'})
                    nexts_ele.css({transform: 'scale(' + this._easingAnim(_currentFrame, 1.25, -0.25, this.totalFrame) + ')'})
                    break;
                case 'Fade':
                    sele.css({opacity: this._easingAnim(_currentFrame, 1, -1, this.totalFrame), zIndex: 9999})
                    break;
            }
        },

        _easingAnim: function(t, b, c, d) {
            return this.linear(t, b, c, d);
        }
    }
    var statics = {

    }

    if (root.AnimEditor) {
        root.AnimEditor.extendScenesEffect('basic', con, methods, statics);
        return;
    }

    return function (AnimEditor) {
        AnimEditor.extendScenesEffect('basic', con, methods, statics);
    }
});



//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-basic.js
// module id = r4Yf
// module chunks = 16